import React from 'react'
import './Hero.scss'

function Hero() {
  return (
    <div className="hero">
      {/*<div className="hero__headline">*/}
      {/*  Auf der Suche nach einer neuen Herausforderung?*/}
      {/*</div>*/}
    </div>
  )
}

export default Hero
